var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("oaFromBox", {
        attrs: {
          isAddBtn: false,
          isViewSearch: false,
          search: _vm.search,
          total: _vm.total,
        },
        on: { addDataFn: _vm.addFinance, confirmData: _vm.confirmData },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-box mt-10" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                height: _vm.tableHeight,
                "tree-props": { children: "children" },
                "default-expand-all": "",
                "row-key": "id",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("toptable.name"),
                  "min-width": "100",
                  prop: "test.name",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("toptable.department"),
                  "min-width": "160",
                  prop: "frame.name",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("user.work.assessmentname"),
                  "min-width": "120",
                  prop: "name",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("toptable.assessmentcycle"),
                  "min-width": "100",
                  prop: "period",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(_vm.getPeriodText(scope.row.period))),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("user.work.qssessmentscore"),
                  "min-width": "80",
                  prop: "score",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("access.assessmentgrade"),
                  "min-width": "100",
                  prop: "level",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("access.openstatus"),
                  "min-width": "80",
                  prop: "is_show",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== 5
                          ? _c("el-switch", {
                              attrs: {
                                "active-text": _vm.$t("access.enabled"),
                                disabled: scope.row.is_show === 1,
                                "inactive-text": _vm.$t("access.notenabled"),
                                value: !(scope.row.is_show === 0),
                                width: 70,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleIsShow(scope.row, 1)
                                },
                              },
                            })
                          : _c("el-switch", {
                              attrs: {
                                "active-text": _vm.$t("access.enabled"),
                                "inactive-text": _vm.$t("access.notenabled"),
                                value: !(scope.row.is_show === 0),
                                width: 70,
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.handleIsShow(scope.row, 2)
                                },
                              },
                            }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "考核状态",
                  "min-width": "110",
                  prop: "status",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTag(scope.row.status).type,
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.getStatusTag(scope.row.status).text
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("access.starttime"),
                  "min-width": "100",
                  prop: "start_time",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm
                                .$moment(scope.row.start_time)
                                .format("yyyy-MM-DD")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("access.endtime"),
                  "min-width": "100",
                  prop: "end_time",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm
                                .$moment(scope.row.end_time)
                                .format("yyyy-MM-DD")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("public.operation"),
                  fixed: "right",
                  prop: "address",
                  width: "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status !== 0
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCheck(scope.row, "check")
                                  },
                                },
                              },
                              [_vm._v("\n            查看\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.userInfoUid == scope.row.check.uid &&
                        scope.row.status == 2
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCheck(
                                      scope.row,
                                      scope.$index
                                    )
                                  },
                                },
                              },
                              [_vm._v("\n            评分\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.userInfoUid == scope.row.check.uid
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleCheck(scope.row, "edit")
                                  },
                                },
                              },
                              [_vm._v("\n            修改考核\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.userInfoUid !== scope.row.check.uid
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleScore(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            评分记录\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-dropdown",
                          { staticClass: "ml10" },
                          [
                            _c(
                              "span",
                              {
                                staticClass:
                                  "el-dropdown-link el-button--text el-button",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("hr.more")) +
                                    "\n              "
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.copy(scope.row, scope.$index)
                                      },
                                    },
                                  },
                                  [_vm._v(" 复制 ")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown-item",
                                  {
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handleDelete(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 删除 ")]
                                ),
                                _vm._v(" "),
                                (scope.row.status == 3 ||
                                  scope.row.status == 4) &&
                                _vm.userInfoUid == scope.row.check.uid
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleScore(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                评分记录\n              "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-fixed" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.where.page,
                  "page-size": _vm.where.limit,
                  "page-sizes": [15, 20, 30],
                  total: _vm.total,
                  layout: "total,sizes, prev, pager, next, jumper",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("score-dialog", { ref: "scoreDialog", attrs: { config: _vm.config } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }